import React from 'react';

import { ClippedTextBox } from '@ast/magma/components/clippedTextBox';

import styles from './SectionHeader.pcss';

export interface SectionHeaderProps {
  readonly isPrimary: boolean;
  readonly title: string;
  readonly subTitle: string;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  isPrimary,
  title,
  subTitle,
}) => (
  <div className={styles.details}>
    <span
      className={styles.title}
      data-stable-name="SettingsSectionHeaderTitle"
    >
      <ClippedTextBox>
        {title}
      </ClippedTextBox>
    </span>
    {isPrimary && (
      <span
        className={styles.primary}
        data-stable-name="SettingsSectionHeaderSubTitle"
      >
        {subTitle}
      </span>
    )}
  </div>
);
